import { useEffect, useRef, useState } from 'react';

const WHATSAPP_NUMBER = '5585999325303';

export default function Footer() {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer id="contato" className="relative w-full bg-background-100 border-t border-background-200/50">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8">
          {/* Brand */}
          <div className="lg:col-span-1">
            <h3 className="font-heading text-2xl md:text-3xl text-primary-800 mb-4">
              Ao Redor do Mundo
            </h3>
            <p className="text-foreground-600 text-sm leading-relaxed mb-6">
              Há mais de 12 anos realizando sonhos e criando experiências de viagem inesquecíveis para pessoas que valorizam o extraordinário.
            </p>
            <div className="flex items-center gap-3">
              {[
                { icon: 'ri-instagram-line', href: 'https://www.instagram.com/aoredordomundoviagens_/' },
                { icon: 'ri-facebook-line', href: '#' },
                { icon: 'ri-whatsapp-line', href: `https://wa.me/${WHATSAPP_NUMBER}` },
                { icon: 'ri-mail-line', href: 'mailto:contato@aoredordomundoviagens.com.br' },
              ].map((social, i) => (
                <a
                  key={i}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50 border border-background-200/60 text-foreground-500 hover:text-primary-600 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Links Rápidos */}
          <div>
            <h4 className="font-label text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              Links Rápidos
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'Home', href: '#hero' },
                { label: 'Sobre', href: '#sobre' },
                { label: 'Destinos', href: '#destinos' },
                { label: 'Intercâmbio', href: '#intercambio' },
                { label: 'Depoimentos', href: '#depoimentos' },
                { label: 'FAQ', href: '#faq' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-foreground-600 hover:text-primary-600 text-sm transition-colors duration-300 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Serviços */}
          <div>
            <h4 className="font-label text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              Serviços
            </h4>
            <ul className="space-y-3">
              {[
                'Viagens Nacionais',
                'Viagens Internacionais',
                'Intercâmbio',
                'Cruzeiros',
                'Lua de Mel',
                'Seguro Viagem',
              ].map((item) => (
                <li key={item}>
                  <span className="text-foreground-600 text-sm">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h4 className="font-label text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              Contato
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-primary-500 mt-0.5"></i>
                <span className="text-foreground-600 text-sm leading-relaxed">
                  Fortaleza, Ceará - Brasil
                </span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-primary-500 mt-0.5"></i>
                <a
                  href={`tel:+55${WHATSAPP_NUMBER.slice(2)}`}
                  className="text-foreground-600 hover:text-primary-600 text-sm transition-colors duration-300 cursor-pointer"
                >
                  (85) 99932-5303
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-whatsapp-line text-primary-500 mt-0.5"></i>
                <a
                  href={`https://wa.me/${WHATSAPP_NUMBER}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-foreground-600 hover:text-primary-600 text-sm transition-colors duration-300 cursor-pointer"
                >
                  WhatsApp
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-primary-500 mt-0.5"></i>
                <a
                  href="mailto:contato@aoredordomundoviagens.com.br"
                  className="text-foreground-600 hover:text-primary-600 text-sm transition-colors duration-300 cursor-pointer"
                >
                  contato@aoredordomundoviagens.com.br
                </a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line text-primary-500 mt-0.5"></i>
                <span className="text-foreground-600 text-sm leading-relaxed">
                  Seg - Sex: 8h às 18h<br />
                  Sáb: 8h às 12h
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Google Maps */}
        <div className="mt-12 rounded-xl overflow-hidden border border-background-200/50">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3981.353544444444!2d-38.5211111!3d-3.7319444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zM8KwNDMnNTUnUyAzOMKwMzEnMTYnVy!5e0!3m2!1spt-BR!2sbr!4v1620000000000!5m2!1spt-BR!2sbr"
            width="100%"
            height="350"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Ao Redor do Mundo Viagens - Fortaleza"
          ></iframe>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-8 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} Ao Redor do Mundo Viagens. Todos os direitos reservados.
          </p>
          <p className="text-foreground-400 text-xs">
            Feito com <i className="ri-heart-fill text-accent-500"></i> em Fortaleza, Ceará
          </p>
        </div>
      </div>

      {/* WhatsApp Floating Button */}
      <a
        href={`https://wa.me/${WHATSAPP_NUMBER}?text=Olá! Gostaria de mais informações sobre as viagens da Ao Redor do Mundo.`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-[90] w-14 h-14 flex items-center justify-center bg-[#25D366] text-white rounded-full hover:scale-110 transition-all duration-300 cursor-pointer"
        style={{ boxShadow: '0 4px 24px rgba(37, 211, 102, 0.35)' }}
        aria-label="Falar no WhatsApp"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </a>

      {/* Scroll to Top */}
      <button
        onClick={scrollToTop}
        className={`fixed bottom-6 right-24 z-[90] w-12 h-12 flex items-center justify-center bg-background-50 border border-background-200/60 text-foreground-600 rounded-full hover:bg-background-100 transition-all duration-500 cursor-pointer ${
          showScrollTop ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
        aria-label="Voltar ao topo"
      >
        <i className="ri-arrow-up-line text-lg"></i>
      </button>
    </footer>
  );
}